import React, { useEffect, useState } from "react";
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FnAxios, I18n } from "utilities/utilities";
import { Grid, Pagination, PaginationItem, Stack, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import usePagination from 'components/Pagination/Pagination';
import './Gallery.css';
import No_Img from "assets/images/NoImage/no-image-available.png";

const GalleryListImg = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const [arrGallery, setarrGallery] = useState([]);
    const onGetData = () => {
        AxiosFn.Get(`GalleryImg/GetGalleryData`, {}, (result) => {
            setarrGallery(result.lstGallery || []);
        })
    }
    useEffect(() => {
        onGetData();
    }, []);

    const onGotoPage = (sID: string) => {
        navigate(`/GalleryDetail?sID=${encodeURI(sID)}`);
    };

    //#region Page All      
    const PER_PAGE = 6;
    let [page, setPage] = useState(1);
    const count = Math.ceil(arrGallery.length / PER_PAGE);
    const _DATA = usePagination(arrGallery, PER_PAGE);

    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
    };

    const pageNext = () => {
        return <>{`${I18n.SetText("Leave.sNext")}`}</>;
    };

    const pagePrevious = () => {
        return <>{`${I18n.SetText("Leave.sPrevious")}`}</>;
    };
    const LayoutWeb = useMediaQuery('(min-width:1180px)');
    const LayoutPhone = useMediaQuery('(min-width:932px)');

    return (
        <React.Fragment>
            <Grid container justifyContent={LayoutPhone ? "" : "center"} spacing={{ xs: 3, md: 1, sm: 3 }} columns={{ xs: 4, sm: 6, md: 12 }}>
                {_DATA.currentData().map((m, index) => {
                    return (
                        <Grid item container justifyContent={"center"} xs={12} sm={11} md={4} key={index} sx={{ mt: "2%" }}>
                            <div className="card">
                                <div className="circle"></div>
                                <div className="circle"></div>
                                <div className="card-inner">
                                    {!LayoutPhone &&
                                        <Grid item sx={{ width: '100%', height: "50vw", padding: "20px 20px 0px 20px" }}>
                                            <Grid container justifyContent={"center"}>
                                                <img
                                                    src={process.env.REACT_APP_API_URL + m.sImg ?? No_Img}
                                                    alt={m.sName}
                                                    style={{
                                                        width: "100%",
                                                        maxHeight: "49vw",
                                                        borderRadius: '6px',
                                                        objectFit: "cover",
                                                        justifyItems: "center"
                                                    }}
                                                    onClick={() => onGotoPage(m.sID)}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                    {LayoutPhone &&
                                        <Grid item sx={{ width: '100%', height: "15vw", padding: "20px 20px 0px 20px" }}>
                                            <Grid container justifyContent={"center"}>
                                                <img
                                                    src={process.env.REACT_APP_API_URL + m.sImg ?? No_Img}
                                                    alt={m.sName}
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "auto",
                                                        minWidth: "auto",
                                                        maxHeight: "14vw",
                                                        borderRadius: '6px',
                                                        objectFit: "cover",
                                                        justifyItems: "center"
                                                    }}
                                                    onClick={() => onGotoPage(m.sID)}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                    <CardContent >
                                        <Grid container justifyContent={"end"}>
                                            <Typography gutterBottom fontWeight={500} fontSize={LayoutWeb ? 20 : 18} component="div">
                                                {m.sDate}
                                            </Typography>
                                        </Grid>
                                        <Grid container justifyContent={"center"}>
                                            <Typography fontSize={LayoutWeb ? 17 : 15} fontWeight={500} color="text.secondary">
                                                {m.sName}
                                            </Typography>
                                        </Grid>
                                        <Grid container justifyContent={"center"}>
                                            <Button className="btx-Gallery" style={{ fontSize: 18 }} onClick={() => onGotoPage(m.sID)}>
                                                ดูเพิ่มเติม
                                            </Button>
                                        </Grid>
                                    </CardContent>
                                </div>
                            </div>
                        </Grid>

                    );
                })}
            </Grid>
            {
                _DATA.currentData().length > 0 && (
                    <Grid item container justifyContent={"center"} xs={12} md={12} spacing={5} style={{ marginTop: 3 }}>
                        <Stack spacing={2} style={{ margin: "1rem auto 2rem", alignItems: "center" }}>
                            <Pagination
                                count={count}
                                page={page}
                                onChange={handleChange}
                                color="primary"
                                renderItem={(item) => <PaginationItem components={{ previous: pagePrevious, next: pageNext }} {...item} />}
                            />
                        </Stack>
                    </Grid>
                )
            }
        </React.Fragment >
    )
}

export default GalleryListImg;
